// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"556a4a2d","423":"a333b416","597":"7be55c42","659":"95f3e888","699":"84235402","762":"9650d7c3","860":"c9280333","935":"a21c7198"}[chunkId] + ".chunk.css";
};